import React from 'react';
import Link from 'next/link';
import { cn } from '@/utils/cn';

function NavigationLink({ className = '', link = '#', label = '' }) {
  return (
    <Link prefetch={false} aria-label="Go to navigation link" href={link}>
      <p
        className={cn(
          'text-14 text-pacific-queen font-encode-sans font-semibold leading-20 tracking-[0.28px] lg:tracking-[0.32px] capitalize line-clamp-1 underline mt-12',
          className,
        )}
      >
        {label}
      </p>
    </Link>
  );
}

export default NavigationLink;
